//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref, computed } from '@vue/composition-api'
import { useUtils } from '@core/libs/i18n'
import { avatarText } from '@core/utils/filter'
import {
  removePlayer, paidPlayer, editMatchInfo, leavePlayer, addGuest, removeGuest,
} from '@api'
import {
  mdiPlus,
  mdiSeal,
  mdiCheck,
  mdiSlashForward,
  mdiInformationOutline,
} from '@mdi/js'
import PlayerAction from '@/views/landing/components/player-action/PlayerAction.vue'

export default {
  name: 'PlayerList',
  components: {
    PlayerAction,
  },
  props: {
    teams: {
      type: Array,
      default: () => [],
      required: true,
    },
    playerQuantity: {
      type: Number,
      default: 0,
      required: true,
    },
    showActions: {
      type: Boolean,
      default: false,
    },
    showEdit: {
      type: Boolean,
      default: false,
    },
    isPrivate: {
      type: Boolean,
      default: false,
    },
    isOrganizer: {
      type: Boolean,
      default: false,
    },
    isPlayer: {
      type: Boolean,
      default: false,
    },
    isJoined: {
      type: Boolean,
      default: false,
      required: true,
    },
    selected: {
      type: [Number, String],
      default: 0,
      required: true,
    },
    teamSelected: {
      type: [Number, String],
      default: -1,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },

    // remove chanllenge
    isChallenge: {
      type: Boolean,
      default: false,
    },
    myTeam: {
      type: String,
      default: '',
    },
    totalVotes: {
      type: Number,
      default: 0,
    },
    canSelectTeam: {
      type: Boolean,
      default: false,
    },
    cancelled: {
      type: Boolean,
      default: false,
    },
    routeTeam: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const { t } = useUtils()

    const slotSelected = computed({
      get: () => props.selected,
      set: value => emit('update-selected', value),
    })

    const slotTeam = computed({
      get: () => props.teamSelected,
      set: value => emit('update-team-selected', value),
    })

    const isDialogChangePlayers = ref(false)
    const isDialogAddGuest = ref(false)
    const dataGuest = ref({
      guest_phone_number: null,
      guest_name: null,
    })

    const computedMatchCode = computed(() => JSON.parse(localStorage.getItem('matchCode')))
    const computedTitle = computed(() => props.title)

    const openClose = val => {
      isDialogChangePlayers.value = val
    }

    const resolvePlayerStyle = (player, active, teamId) => {
      if (player.its_me) return { border: '2px solid #14AE5C !important' }
      if (active && player.empty && !props.isJoined) return { border: '1.5px solid #14AE5C !important', backgroundColor: '#14ae5c40 !important' }
      if (!props.isChallenge && !player.selectable && player.empty && props.isJoined) return { border: '1.5px dashed #3f3f3f !important' }
      if (!player.selectable && player.empty && props.isJoined && props.myTeam === teamId) return { border: '1.5px dashed #3f3f3f !important' }
      if (!player.selectable || (props.canSelectTeam && teamId === 'B')) return { border: '1.5px solid #3f3f3f !important' }
      if (player.empty) return { border: '1.5px dashed #3f3f3f !important' }

      return {}
    }

    const resolveSlotTeamStyle = (active, teamId, canSelectTeam) => {
      if (active && teamId === 'B' && canSelectTeam) return { border: '1.5px solid #14AE5C !important', backgroundColor: '#14ae5c40 !important' }
      if (active && teamId === 'B' && canSelectTeam) return { border: '1.5px solid #14AE5C !important', backgroundColor: '#14ae5c40 !important' }
      if (!active && teamId === 'B' && canSelectTeam) return { border: '1.5px dashed #3f3f3f !important' }

      return { border: '1.5px solid #cecece !important' }
    }

    const resolveBadgeColor = player => {
      if (player.nprd !== null) {
        if (player.nprd === 0) return '#FFBD1B'
        if (player.nprd > 0) return '#14AE5C'
        if (player.nprd < 0) return '#FF3232'
      }

      if (player.pr !== null) return '#3F3F3F'

      return '#3F3F3F'
    }

    const onChangeQuantity = async val => {
      const resp = await editMatchInfo(computedMatchCode.value, { match_players_qty: val })
      if (resp.ok) {
        isDialogChangePlayers.value = false
        emit('refresh-match')
      }
    }

    const openCloseAddGuest = val => {
      isDialogAddGuest.value = true
      dataGuest.value.slot = val
    }

    const onAddGuest = async val => {
      dataGuest.value.guest_name = val.guest_name
      dataGuest.value.guest_phone_number = val.guest_phone_number
      dataGuest.value.match_code = computedMatchCode.value

      const resp = await addGuest(dataGuest.value)
      if (resp.ok) {
        isDialogAddGuest.value = false
        emit('refresh-match')
      }
    }

    const onLeave = async () => {
      const resp = await leavePlayer(computedMatchCode.value)
      if (resp.ok) emit('refresh-match')
    }

    const onRemovePlayer = async (user, guest, slot) => {
      let resp = null
      if (guest) resp = await removeGuest(computedMatchCode.value, slot)
      else resp = await removePlayer(computedMatchCode.value, user)

      if (resp.ok) emit('refresh-match')
    }

    const onPayPlayer = async (paid, slot, isOrganizer) => {
      if (isOrganizer) {
        const resp = await paidPlayer(computedMatchCode.value, {
          match_player_paid: paid,
          slot,
        })

        if (resp.ok) emit('refresh-match')
      }
    }

    return {
      // data
      isDialogChangePlayers,
      isDialogAddGuest,
      slotSelected,
      slotTeam,

      // computed
      computedTitle,

      // methods
      openClose,
      onChangeQuantity,
      openCloseAddGuest,
      onAddGuest,
      onRemovePlayer,
      onPayPlayer,
      onLeave,
      avatarText,
      resolvePlayerStyle,
      resolveSlotTeamStyle,
      resolveBadgeColor,

      // i18n
      t,

      icons: {
        mdiPlus,
        mdiSeal,
        mdiCheck,
        mdiSlashForward,
        mdiInformationOutline,
        moneyBill: require('@/assets/images/svg/money-bill.svg'),
      },
    }
  },
}
